module.exports = __webpack_public_path__ + "static/website-icon-0b16cd5fb66402e1ba9ab9a9e5432cda.png";